module.exports = __webpack_public_path__ + "img/product_1.516d90e.webp";